import React from "react";
import { useMediaQuery } from "@mui/system";
import { Grid } from "@mui/material";
import { FunctionField } from "react-admin";
import { settings } from "app";
import { StaffRequestTypes } from "utils/constants";
import RequestActionBox from "../RequestActionBox";
import ApproversTable from "./ApproversTable";
import { SectionTitle } from "features/SectionTitle";

const ApproversSection = ({ type, showActions = true }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const title = type === StaffRequestTypes.AnnualLeave ? "Одобряващи" : "Одобряващи преподаватели";

  return (
    <>
      <SectionTitle
        title={title}
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={showActions ? 8 : 12}
        >
          <ApproversTable />
        </Grid>
        {showActions && (
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <FunctionField
              render={rec => (
                <RequestActionBox
                  type={type}
                  status={rec?.staffRequest?.status}
                />
              )}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default ApproversSection;
